import { render, staticRenderFns } from "./priming.vue?vue&type=template&id=69a7779c"
import script from "./priming.vue?vue&type=script&lang=ts"
export * from "./priming.vue?vue&type=script&lang=ts"
import style0 from "./priming.vue?vue&type=style&index=0&id=69a7779c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports